export default () => ({
  products: [],
  productMeta: {},
  product: {},
});
